// HERE's map.dispose() resets WebGL shader state that every HERE map on the page shares, so the
// next map created afterwards throws "Cannot read properties of null (reading 'lookAtManipulator')"
// once its style loads (seen as "Script error." when switching Dispatch Dashboard <-> Admin Console).
// Instead of disposing and recreating, each map page keeps one map alive for the whole session and
// moves its element in and out of the page.
const keptMaps = {};

// Puts the kept map for `key` inside `container`, creating it with `create(element)` the first time.
export const attachHereMap = (key, container, create) => {
  let entry = keptMaps[key];
  if (entry) {
    container.appendChild(entry.element);
    entry.map.getViewPort().resize();
    return entry.map;
  }

  const element = document.createElement('div');
  element.style.width = '100%';
  element.style.height = '100%';
  element.style.borderRadius = 'inherit';
  container.appendChild(element);
  let map;
  try {
    map = create(element);
  } catch (err) {
    element.remove();
    throw err;
  }
  entry = { element, map };
  // Follow the element's own size: layout changes (header wrapping, rotating a phone) resize it
  // without a window resize. A detached element reports 0x0, which the map must not be sized to.
  new ResizeObserver(() => {
    if (element.isConnected && element.offsetWidth > 0) map.getViewPort().resize();
  }).observe(element);
  keptMaps[key] = entry;
  return map;
};

// Takes the kept map off the page and clears the markers and routes the page added to it.
export const detachHereMap = (key) => {
  const entry = keptMaps[key];
  if (!entry) return;
  entry.map.removeObjects(entry.map.getObjects());
  entry.element.remove();
};
